import { useValidatorContext } from "./provider";

export const useResetValidationErrors = () => {
    const { resetAllFieldErrors } = useValidatorContext();
    return resetAllFieldErrors;
};
